const { DateTime } = require("luxon");

export const formatToDMYHM = (isoString) => {
  return DateTime.fromISO(isoString, { zone: "UTC" })
    .setZone("America/Bogota") // Convertir a la zona horaria de Bogotá
    .toFormat("dd/MM/yyyy hh:mm a");
};
